var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ARIAL_FONT } from 'pxc-editor-material-svg-rendering/constants';
import { colors } from '@/globalStyles';
import { DEFAULT_SHAPE_PARAMS, SECTION_SUFFIX, DEFAULT_GRAPHIC_SCALE } from '@/constants';
import { parseId } from '../helpers/schema';
import { safeObjCopy } from '../helpers/common';
var Section = /** @class */ (function () {
    function Section(data) {
        Object.defineProperty(this, "x", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "y", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "width", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "height", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shieldId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sourceSectionId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hasBackground", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fillColor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "angle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mirrorX", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mirrorY", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isChanged", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "text", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fontSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isBold", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isItalic", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isUnderline", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "font", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "horizontalAlignment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "verticalAlignment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fontColor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // { text: string, bcid: string, ...otherCodeOptions}
        Object.defineProperty(this, "barcodeColor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "symbolFont", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "glyph", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "glyphFillColor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "image", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "numInstances", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "children", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "laserOutputQuality", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shape", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shapeStrokeColor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shapeFillColor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "graphicFormattingScale", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        var x = data.x, y = data.y, width = data.width, height = data.height, id = data.id, shieldId = data.shieldId, _a = data.fillColor, fillColor = _a === void 0 ? null : _a, _b = data.text, text = _b === void 0 ? '' : _b, _c = data.sourceSectionId, sourceSectionId = _c === void 0 ? null : _c, _d = data.isChanged, isChanged = _d === void 0 ? false : _d;
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.id = id;
        this.shieldId = shieldId;
        this.sourceSectionId = sourceSectionId;
        this.isChanged = isChanged;
        this.hasBackground = false;
        this.fillColor = fillColor;
        this.angle = 0;
        this.mirrorX = false;
        this.mirrorY = false;
        this.type = 'text';
        this.text = text;
        this.fontSize = 2.8;
        this.isBold = false;
        this.isItalic = false;
        this.isUnderline = false;
        this.font = ARIAL_FONT;
        this.horizontalAlignment = 'center';
        this.verticalAlignment = 'middle';
        this.fontColor = colors.black;
        this.code = null; // { text: string, bcid: string, ...otherCodeOptions}
        this.barcodeColor = colors.black;
        this.symbolFont = 'PxC_Symb-Additional';
        this.glyph = null; // { unicode: int }
        this.glyphFillColor = colors.black;
        this.image = null;
        this.numInstances = Section.counter;
        this.laserOutputQuality = null;
        this.shape = null;
        this.shapeStrokeColor = DEFAULT_SHAPE_PARAMS.STROKE_COLOR;
        this.shapeFillColor = DEFAULT_SHAPE_PARAMS.FILL_COLOR;
        this.graphicFormattingScale = DEFAULT_GRAPHIC_SCALE;
    }
    Object.defineProperty(Section, "counter", {
        get: function () {
            return Section._counter = (Section._counter || 0) + 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Section, "fromDict", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            var x = data.x, y = data.y, width = data.width, height = data.height, id = data.id, shieldId = data.shieldId, fillColor = data.fillColor, text = data.text, sourceSectionId = data.sourceSectionId, fontSize = data.fontSize, isBold = data.isBold, isItalic = data.isItalic, isUnderline = data.isUnderline, font = data.font, horizontalAlignment = data.horizontalAlignment, verticalAlignment = data.verticalAlignment, fontColor = data.fontColor, hasBackground = data.hasBackground, symbolFont = data.symbolFont, angle = data.angle, mirrorX = data.mirrorX, mirrorY = data.mirrorY, type = data.type, glyph = data.glyph, glyphFillColor = data.glyphFillColor, code = data.code, barcodeColor = data.barcodeColor, image = data.image, isChanged = data.isChanged, laserOutputQuality = data.laserOutputQuality, shape = data.shape, shapeStrokeColor = data.shapeStrokeColor, shapeFillColor = data.shapeFillColor, graphicFormattingScale = data.graphicFormattingScale;
            var newSec = new Section({
                x: x,
                y: y,
                width: width,
                height: height,
                id: id,
                shieldId: shieldId,
                fillColor: fillColor,
                text: text,
                sourceSectionId: sourceSectionId,
                isChanged: isChanged,
            });
            newSec
                .setFontSize(fontSize)
                .setBold(isBold)
                .setItalic(isItalic)
                .setUnderline(isUnderline)
                .setFont(font)
                .setHorizontalAlignment(horizontalAlignment)
                .setVerticalAlignment(verticalAlignment)
                .setFontColor(fontColor)
                .setBackgroundState(hasBackground)
                .setSymbolFont(symbolFont)
                .setAngle(angle)
                .setMirrorX(mirrorX)
                .setMirrorY(mirrorY)
                .setType(type)
                .setGlyph(glyph)
                .setGlyphFillColor(glyphFillColor)
                .setCode(code)
                .setBarcodeColor(barcodeColor)
                .setImage(image)
                .setChanged(isChanged)
                .setLaserOutputQuality(laserOutputQuality)
                .setShape(shape)
                .setShapeStokeColor(shapeStrokeColor)
                .setShapeFillColor(shapeFillColor)
                .setGraphicFormattingScale(graphicFormattingScale);
            return newSec;
        }
    });
    Object.defineProperty(Section, "contentIsEmpty", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            return (data.text === "" && data.code === null && data.glyph === null && data.image === null && data.shape === null);
        }
    });
    Object.defineProperty(Section, "getContent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            var text = data.text, code = data.code, glyph = data.glyph, symbolFont = data.symbolFont, image = data.image, shape = data.shape;
            return { text: text, code: code, glyph: glyph, symbolFont: symbolFont, image: image, shape: shape };
        }
    });
    Object.defineProperty(Section, "getContentSettings", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            var x = data.x, y = data.y, width = data.width, height = data.height, sourceSectionId = data.sourceSectionId, shieldId = data.shieldId, numInstances = data.numInstances, isChanged = data.isChanged, id = data.id, children = data.children, text = data.text, code = data.code, glyph = data.glyph, image = data.image, shape = data.shape, rest = __rest(data, ["x", "y", "width", "height", "sourceSectionId", "shieldId", "numInstances", "isChanged", "id", "children", "text", "code", "glyph", "image", "shape"]);
            return __assign({}, rest);
        }
    });
    Object.defineProperty(Section, "getContentWithSettings", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            var x = data.x, y = data.y, width = data.width, height = data.height, sourceSectionId = data.sourceSectionId, shieldId = data.shieldId, numInstances = data.numInstances, isChanged = data.isChanged, id = data.id, children = data.children, rest = __rest(data, ["x", "y", "width", "height", "sourceSectionId", "shieldId", "numInstances", "isChanged", "id", "children"]);
            return __assign({}, rest);
        }
    });
    Object.defineProperty(Section, "getBaseSettings", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            var x = data.x, y = data.y, width = data.width, height = data.height, id = data.id, shieldId = data.shieldId, sourceSectionId = data.sourceSectionId, numInstances = data.numInstances;
            return { x: x, y: y, width: width, height: height, id: id, shieldId: shieldId, sourceSectionId: sourceSectionId, numInstances: numInstances };
        }
    });
    Object.defineProperty(Section, "resetContent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            return __assign(__assign({}, data), { text: '', code: null, glyph: null, symbolFont: 'PxC_Symb-Additional', image: null, shape: null });
        }
    });
    Object.defineProperty(Section.prototype, "toDict", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var rawData = __rest(this, []);
            return rawData;
        }
    });
    Object.defineProperty(Section.prototype, "copySection", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (_a) {
            var height = _a.height, width = _a.width, x = _a.x, y = _a.y, angle = _a.angle, mirrorX = _a.mirrorX, mirrorY = _a.mirrorY, hasBackground = _a.hasBackground, fillColor = _a.fillColor, text = _a.text, fontColor = _a.fontColor, font = _a.font, fontSize = _a.fontSize, isItalic = _a.isItalic, isBold = _a.isBold, isUnderline = _a.isUnderline, horizontalAlignment = _a.horizontalAlignment, verticalAlignment = _a.verticalAlignment, code = _a.code, barcodeColor = _a.barcodeColor, image = _a.image, glyph = _a.glyph, symbolFont = _a.symbolFont, glyphFillColor = _a.glyphFillColor, isChanged = _a.isChanged, laserOutputQuality = _a.laserOutputQuality, shape = _a.shape, shapeStrokeColor = _a.shapeStrokeColor, shapeFillColor = _a.shapeFillColor, graphicFormattingScale = _a.graphicFormattingScale;
            this
                .setWidth(width)
                .setHeight(height)
                .setX(x)
                .setY(y)
                .setBackgroundState(hasBackground)
                .setAngle(angle)
                .setMirrorX(mirrorX)
                .setMirrorY(mirrorY)
                .setText(text)
                .setCode(safeObjCopy(code))
                .setGlyph(safeObjCopy(glyph))
                .setImage(safeObjCopy(image))
                .setBarcodeColor(barcodeColor)
                .setSymbolFont(symbolFont)
                .setGlyphFillColor(glyphFillColor)
                .setFontColor(fontColor)
                .setFont(font)
                .setItalic(isItalic)
                .setBold(isBold)
                .setUnderline(isUnderline)
                .setFontSize(fontSize)
                .setHorizontalAlignment(horizontalAlignment)
                .setVerticalAlignment(verticalAlignment)
                .setChanged(isChanged)
                .setLaserOutputQuality(laserOutputQuality)
                .setShape(shape)
                .setShapeStokeColor(shapeStrokeColor)
                .setShapeFillColor(shapeFillColor)
                .setGraphicFormattingScale(graphicFormattingScale);
            if (this.hasBackground) {
                this.setFillColor(fillColor);
            }
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "clone", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return new Section({
                x: this.x,
                y: this.y,
                width: this.width,
                height: this.height,
                id: this.id,
                shieldId: this.shieldId,
                fillColor: this.fillColor,
                text: this.text,
                sourceSectionId: this.sourceSectionId
            })
                .setBold(this.isBold)
                .setUnderline(this.isUnderline)
                .setFontColor(this.fontColor)
                .setItalic(this.isItalic)
                .setFontSize(this.fontSize)
                .setFont(this.font)
                .setHorizontalAlignment(this.horizontalAlignment)
                .setVerticalAlignment(this.verticalAlignment)
                .setBackgroundState(this.hasBackground)
                .setSymbolFont(this.symbolFont)
                .setAngle(this.angle)
                .setMirrorX(this.mirrorX)
                .setMirrorY(this.mirrorY)
                .setType(this.type)
                .setGlyph(safeObjCopy(this.glyph))
                .setGlyphFillColor(this.glyphFillColor)
                .setCode(safeObjCopy(this.code))
                .setBarcodeColor(this.barcodeColor)
                .setImage(safeObjCopy(this.image))
                .setChanged(this.isChanged)
                .setLaserOutputQuality(this.laserOutputQuality)
                .setShape(safeObjCopy(this.shape))
                .setShapeStokeColor(this.shapeStrokeColor)
                .setShapeFillColor(this.shapeFillColor)
                .setGraphicFormattingScale(this.graphicFormattingScale);
        }
    });
    Object.defineProperty(Section.prototype, "splitVertical", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return [
                new Section({
                    x: this.x,
                    y: this.y,
                    width: this.width / 2,
                    height: this.height,
                    id: "".concat(this.id, "_1"),
                    shieldId: this.shieldId,
                    fillColor: this.fillColor,
                    text: this.text
                })
                    .setBold(this.isBold)
                    .setUnderline(this.isUnderline)
                    .setFontColor(this.fontColor)
                    .setItalic(this.isItalic)
                    .setFontSize(this.fontSize)
                    .setFont(this.font)
                    .setHorizontalAlignment(this.horizontalAlignment)
                    .setVerticalAlignment(this.verticalAlignment)
                    .setBackgroundState(this.hasBackground)
                    .setSymbolFont(this.symbolFont)
                    .setAngle(this.angle)
                    .setMirrorX(this.mirrorX)
                    .setMirrorY(this.mirrorY)
                    .setType(this.type)
                    .setGlyph(safeObjCopy(this.glyph))
                    .setGlyphFillColor(this.glyphFillColor)
                    .setCode(safeObjCopy(this.code))
                    .setBarcodeColor(this.barcodeColor)
                    .setImage(safeObjCopy(this.image))
                    .setChanged(true)
                    .setLaserOutputQuality(this.laserOutputQuality)
                    .setShape(this.shape)
                    .setShapeStokeColor(this.shapeStrokeColor)
                    .setShapeFillColor(this.shapeFillColor)
                    .setGraphicFormattingScale(this.graphicFormattingScale),
                new Section({
                    x: this.x + this.width / 2,
                    y: this.y,
                    width: this.width / 2,
                    height: this.height,
                    id: "".concat(this.id, "_2"),
                    shieldId: this.shieldId,
                    fillColor: this.fillColor,
                    text: ''
                })
                    .setBold(this.isBold)
                    .setUnderline(this.isUnderline)
                    .setFontColor(this.fontColor)
                    .setItalic(this.isItalic)
                    .setFontSize(this.fontSize)
                    .setFont(this.font)
                    .setHorizontalAlignment(this.horizontalAlignment)
                    .setVerticalAlignment(this.verticalAlignment)
                    .setBackgroundState(this.hasBackground)
                    .setSymbolFont(this.symbolFont)
                    .setAngle(this.angle)
                    .setMirrorX(this.mirrorX)
                    .setMirrorY(this.mirrorY)
                    .setType(this.type)
                    .setGlyphFillColor(this.glyphFillColor)
                    .setBarcodeColor(this.barcodeColor)
                    .setChanged(true)
                    .setLaserOutputQuality(this.laserOutputQuality)
                    .setShapeStokeColor(this.shapeStrokeColor)
                    .setShapeFillColor(this.shapeFillColor)
                    .setGraphicFormattingScale(this.graphicFormattingScale),
            ];
        }
    });
    Object.defineProperty(Section.prototype, "splitHorizontal", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return [
                new Section({
                    x: this.x,
                    y: this.y,
                    width: this.width,
                    height: this.height / 2,
                    id: "".concat(this.id, "_3"),
                    shieldId: this.shieldId,
                    fillColor: this.fillColor,
                    text: this.text,
                })
                    .setBold(this.isBold)
                    .setUnderline(this.isUnderline)
                    .setFontColor(this.fontColor)
                    .setItalic(this.isItalic)
                    .setFontSize(this.fontSize)
                    .setFont(this.font)
                    .setHorizontalAlignment(this.horizontalAlignment)
                    .setVerticalAlignment(this.verticalAlignment)
                    .setBackgroundState(this.hasBackground)
                    .setSymbolFont(this.symbolFont)
                    .setAngle(this.angle)
                    .setMirrorX(this.mirrorX)
                    .setMirrorY(this.mirrorY)
                    .setType(this.type)
                    .setGlyph(safeObjCopy(this.glyph))
                    .setGlyphFillColor(this.glyphFillColor)
                    .setCode(safeObjCopy(this.code))
                    .setBarcodeColor(this.barcodeColor)
                    .setImage(safeObjCopy(this.image))
                    .setChanged(true)
                    .setShape(this.shape)
                    .setShapeStokeColor(this.shapeStrokeColor)
                    .setShapeFillColor(this.shapeFillColor)
                    .setGraphicFormattingScale(this.graphicFormattingScale),
                new Section({
                    x: this.x,
                    y: this.y + this.height / 2,
                    width: this.width,
                    height: this.height / 2,
                    id: "".concat(this.id, "_4"),
                    shieldId: this.shieldId,
                    fillColor: this.fillColor,
                    text: '',
                })
                    .setBold(this.isBold)
                    .setUnderline(this.isUnderline)
                    .setFontColor(this.fontColor)
                    .setItalic(this.isItalic)
                    .setFontSize(this.fontSize)
                    .setFont(this.font)
                    .setHorizontalAlignment(this.horizontalAlignment)
                    .setVerticalAlignment(this.verticalAlignment)
                    .setBackgroundState(this.hasBackground)
                    .setSymbolFont(this.symbolFont)
                    .setAngle(this.angle)
                    .setMirrorX(this.mirrorX)
                    .setMirrorY(this.mirrorY)
                    .setType(this.type)
                    .setGlyphFillColor(this.glyphFillColor)
                    .setBarcodeColor(this.barcodeColor)
                    .setChanged(true)
                    .setShapeStokeColor(this.shapeStrokeColor)
                    .setShapeFillColor(this.shapeFillColor)
                    .setGraphicFormattingScale(this.graphicFormattingScale),
            ];
        }
    });
    Object.defineProperty(Section.prototype, "clearContent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.text = '';
            this.code = null;
            this.glyph = null;
            this.symbolFont = 'PxC_Symb-Additional';
            this.image = null;
            this.shape = null;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setUnderline", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isUnderline) {
            this.isUnderline = isUnderline;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setImage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (image) {
            this.image = image;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isChanged) {
            this.isChanged = isChanged;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setBarcodeColor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (color) {
            this.barcodeColor = color;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setCode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (code) {
            this.code = code;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setGlyphFillColor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (glyphFillColor) {
            this.glyphFillColor = glyphFillColor;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setGlyph", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (glyph) {
            this.glyph = glyph;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setContentGlyph", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (glyph) {
            this.glyph = glyph;
            this.setText('').setImage(null).setCode(null);
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            this.type = type;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setAngle", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (angle) {
            this.angle = angle;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setMirrorX", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (mirrorX) {
            this.mirrorX = mirrorX;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setMirrorY", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (mirrorY) {
            this.mirrorY = mirrorY;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setSymbolFont", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (symbolFont) {
            this.symbolFont = symbolFont;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setBackgroundState", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (hasBackground) {
            this.hasBackground = hasBackground;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setFontColor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (color) {
            this.fontColor = color;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setSourceSectionId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (secId) {
            this.sourceSectionId = secId;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setVerticalAlignment", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (vertAlignment) {
            this.verticalAlignment = vertAlignment;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setHorizontalAlignment", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (horAlignment) {
            this.horizontalAlignment = horAlignment;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setFontSize", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fontSize) {
            this.fontSize = fontSize;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setX", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.x = value;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setY", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.y = value;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setWidth", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.width = value;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setHeight", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.height = value;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setFillColor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.fillColor = value;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setText", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (text) {
            this.text = text;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (children) {
            if (children === void 0) { children = []; }
            var newChildren = [];
            if (children === null || children === void 0 ? void 0 : children.length) {
                children.forEach(function (child) {
                    var section = Section.fromDict(child).clone().setNewIdById(child.id);
                    newChildren.push(section);
                });
            }
            this.children = newChildren;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setContentText", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (text) {
            this.text = text;
            this.setGlyph(null).setImage(null).setCode(null);
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setBold", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isBold) {
            this.isBold = isBold;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setItalic", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isItalic) {
            this.isItalic = isItalic;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setFont", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (font) {
            this.font = font;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setNewIdById", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            var _a = parseId(id), pageId = _a.pageId, layoutId = _a.layoutId, groupId = _a.groupId, shieldId = _a.shieldId, sectionId = _a.sectionId;
            if (shieldId) {
                this.shieldId = shieldId;
                this.id = "".concat(shieldId).concat(SECTION_SUFFIX).concat(this.numInstances + 1);
            }
            else {
                throw 'Wrong id value';
            }
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setLaserOutputQuality", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            if (value === void 0) { value = null; }
            this.laserOutputQuality = value;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setShape", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            if (value === void 0) { value = null; }
            this.shape = value;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setShapeStokeColor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            if (value === void 0) { value = DEFAULT_SHAPE_PARAMS.STROKE_COLOR; }
            this.shapeStrokeColor = value;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setShapeFillColor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            if (value === void 0) { value = DEFAULT_SHAPE_PARAMS.FILL_COLOR; }
            this.shapeFillColor = value;
            return this;
        }
    });
    Object.defineProperty(Section.prototype, "setGraphicFormattingScale", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            if (value === void 0) { value = DEFAULT_GRAPHIC_SCALE; }
            this.graphicFormattingScale = value;
            return this;
        }
    });
    return Section;
}());
export default Section;
